(() => {
    const counters = document.querySelectorAll('[data-usp-counter]');
    if (!counters.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const DURATION_MS = 2500;
    const easeOut = (t) => 1 - Math.pow(1 - t, 4);

    const formatValue = (value, decimals) => {
        if (decimals <= 0) {
            return Math.round(value).toLocaleString('sv-SE', { useGrouping: false });
        }
        return value.toLocaleString('sv-SE', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
            useGrouping: false,
        });
    };

    const animate = (el) => {
        const target = parseFloat(el.getAttribute('data-target'));
        const decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
        if (!Number.isFinite(target)) return;

        if (reduceMotion) {
            el.textContent = formatValue(target, decimals);
            return;
        }

        const start = performance.now();
        const step = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / DURATION_MS, 1);
            const value = target * easeOut(progress);
            el.textContent = formatValue(value, decimals);
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = formatValue(target, decimals);
            }
        };
        el.textContent = formatValue(0, decimals);
        requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
        counters.forEach(animate);
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                animate(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    counters.forEach((el) => observer.observe(el));
})();
